declare global {
  interface Window {
    __API_URL__?: string;
  }
}

/**
 * Backend API base, including `/api`.
 * Runtime `window.__API_URL__` (written on Railway start) wins over the
 * build-time REACT_APP_API_URL, so the client URL can be changed without a code change.
 */
export function getApiUrl(): string {
  const runtime =
    typeof window !== 'undefined' ? (window.__API_URL__ || '').trim() : '';
  const fromEnv = (process.env.REACT_APP_API_URL || '').trim();
  return (runtime || fromEnv || 'http://localhost:5001/api').replace(/\/$/, '');
}
